module.exports = __webpack_public_path__ + "static/media/carta_62.20ba203f.jpg";